const EVENT_TYPE = {
  meeting: 'MEETING',
  companyVisit: 'COMPANY_VISIT',
  outing: 'OUTING',
};

export default EVENT_TYPE;
